
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--roboneo/ai_watermark",
      function () {
        return require("private-next-pages/--roboneo/ai_watermark/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--roboneo/ai_watermark"])
      });
    }
  